import { observer } from 'mobx-react-lite'
import React from 'react'
import { Icon, type IFieldDropdownErrorProps, SpinnerLoader } from 'shared/ui'
import {
  type ITextFieldBaseAsideAction,
  type ITextFieldPlaceholderProps,
  makeTextFieldError,
  TextFieldPlaceholder,
} from 'shared/ui/TextField'
import styles from 'widgets/SendFrom/ui/styles.module.scss'
import { useSendFromContext } from 'widgets/SendFrom/context/context'
import { SendFromTriggerInnerContent } from 'widgets/SendFrom/ui/SendFromTriggerInnerContent/SendFromTriggerInnerContent'

export type ITextFiledTriggerProps = {
  error?: IFieldDropdownErrorProps
  rightActions?: ITextFieldBaseAsideAction[]
  textFieldPlaceholderProps?: Partial<ITextFieldPlaceholderProps>
}

export const TextFiledTrigger = observer(
  ({ error, rightActions, textFieldPlaceholderProps }: ITextFiledTriggerProps) => {
    const { loading, error: storeError, selectedDropdownItem } = useSendFromContext()
    return (
      <TextFieldPlaceholder
        placeholder={
          <div className={styles.trigger}>
            {loading ? (
              <div className={styles.loading}>
                <Icon icon='inboxes2' />
                <SpinnerLoader
                  ariaLabel={'TextFiledTrigger'}
                  size={10}
                  indeterminatecolor={'var(--content-primary-tertiary)'}
                />
              </div>
            ) : (
              <SendFromTriggerInnerContent item={selectedDropdownItem} />
            )}
          </div>
        }
        variant={'outline'}
        size={'small'}
        error={error?.message || storeError}
        rightActions={[
          makeTextFieldError({
            placement: error?.placement ?? 'right',
            boundaryElement: error?.boundaryElement,
            offset: error?.offset,
            anchor: error?.anchor,
            showIcon: error?.showIcon,
          }),
          ...(rightActions || []),
        ]}
        {...textFieldPlaceholderProps}
      />
    )
  }
)
